module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.bundleConfigViewFlag) ? _c('div', {
    staticClass: "row"
  }, [(_vm.bundleConfigEditFlag) ? _c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.actualBundleIsDefaultBundle == false) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h4', {
    staticClass: "font-w300 push"
  }, [_vm._v(_vm._s(_vm.textLabelBundleID[_vm.actualLanguage]) + " : " + _vm._s(_vm.actualBundle.bundle_id.split("::").pop()))]), _vm._v(" "), (_vm.flagDisplayCompleteBundleName) ? _c('h4', {
    staticClass: "font-w300 push"
  }, [_vm._v(_vm._s(_vm.textLabelBundleID[_vm.actualLanguage]) + " : " + _vm._s(_vm.actualBundle.bundle_id))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('div', [_c('p', [_c('button', {
    staticClass: "h3 btn btn-block btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveNewBundleName()
      }
    }
  }, [(_vm.newBundleIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.buttonLabelModifySystemName[_vm.actualLanguage]))])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('div', [_c('p', [(_vm.flagDisplayDeleteBundle) ? _c('button', {
    staticClass: "h3 btn btn-block btn-danger align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.deleteBundle()
      }
    }
  }, [(_vm.bundleIsDeleting) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-trash fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelDeleteSystem[_vm.actualLanguage]))])], 1) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [(false) ? _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('div', [_c('p', [(_vm.bundleConfigEditFlag) ? _c('button', {
    staticClass: "h3 btn btn-block btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createNewBundleInGroup()
      }
    }
  }, [(_vm.addBundleIsSaving2) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _c('i', {
    staticClass: "fa fa-usb fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelCreateSameLevelSystem[_vm.actualLanguage]))])], 1) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('div', [_c('p', [(_vm.bundleConfigEditFlag) ? _c('button', {
    staticClass: "h3 btn btn-block btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveNewSubBundle()
      }
    }
  }, [(_vm.addBundleIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _c('i', {
    staticClass: "fa fa-usb fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelCreateSubSystem[_vm.actualLanguage]))])], 1) : _vm._e()])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.bundleSharingEnableFlag) ? _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplaySharing === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplaySharing()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplaySharing) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplaySharing()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "h4 block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplaySharing()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-alt fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.blocTitleSharing[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplaySharing) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.bundleConfigEditFlag) ? _c('div', {
    staticClass: "col-xs-12 push"
  }, [(_vm.bundleSharingEnableFlag) ? _c('button', {
    staticClass: "btn btn-block btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.shareEntity()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-alt fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelShareSystem[_vm.actualLanguage]) + " : " + _vm._s(_vm.actualBundle.bundle_name))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('h6', {
    staticClass: "font-w200"
  }, [_vm._v(_vm._s(_vm.textSharingDetail[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('h4', {
    staticClass: "push-5-r "
  }, [_vm._v(_vm._s(_vm.blocTitleSharingList[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('config-sharing-list', {
    attrs: {
      "sharingListData": {
        sharingType: 'Bundle'
      }
    }
  })], 1)])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayAttributes === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayAttributes()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayAttributes) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayAttributes()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "h4 block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayAttributes()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-tags fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.blocLabelTags[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayAttributes) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 items-push"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h6', {
    staticClass: "font-w200"
  }, [_vm._v(_vm._s(_vm.textDescriptionTags[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.bundleConfigEditFlag) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('button', {
    staticClass: "btn btn-xs align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.addAttributeCategorie()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelAddTagCategory[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.actualBundle.channelsAttributes), function(categoryList, index) {
    return _c('div', [_c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-xs-12",
      attrs: {
        "for": "example-multiple-select"
      }
    }, [_vm._v(_vm._s(categoryList.title))]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.channelAttributeSelect[index]),
        expression: "channelAttributeSelect[index]"
      }],
      staticClass: "form-control",
      attrs: {
        "id": "example-multiple-select",
        "name": "example-multiple-select",
        "size": "5"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.channelAttributeSelect, index, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((categoryList.data), function(element, index2) {
      return _c('option', {
        domProps: {
          "value": index2
        }
      }, [_vm._v(_vm._s(element))])
    }), 0)]), _vm._v(" "), (_vm.bundleConfigEditFlag) ? _c('button', {
      staticClass: "btn btn-xs",
      attrs: {
        "type": "button",
        "name": "buttonAddPlanItem"
      },
      on: {
        "click": function($event) {
          return _vm.addAttributeElement(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus fa-1x push-5-r "
    }), _vm._v(_vm._s(_vm.buttonLabelAddTag[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (_vm.bundleConfigEditFlag) ? _c('button', {
      staticClass: "btn btn-xs",
      attrs: {
        "type": "button",
        "name": "buttonAddPlanItem"
      },
      on: {
        "click": function($event) {
          return _vm.deleteAttributeElement(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash fa-1x push-5-r "
    }), _vm._v(_vm._s(_vm.buttonLabelDeleteTag[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (_vm.bundleConfigEditFlag) ? _c('button', {
      staticClass: "btn btn-xs",
      attrs: {
        "type": "button",
        "name": "buttonAddPlanItem"
      },
      on: {
        "click": function($event) {
          return _vm.deleteCategoryList(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash fa-1x push-5-r "
    }), _vm._v(_vm._s(_vm.buttonLabelDeleteTagCategory[_vm.actualLanguage]))]) : _vm._e()])])])
  }), 0), _vm._v(" "), (_vm.bundleConfigEditFlag) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actualBundle.bundle_configuration.channelDisplayOptions.attributesDisplayFlag),
      expression: "actualBundle.bundle_configuration.channelDisplayOptions.attributesDisplayFlag"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.actualBundle.bundle_configuration.channelDisplayOptions.attributesDisplayFlag) ? _vm._i(_vm.actualBundle.bundle_configuration.channelDisplayOptions.attributesDisplayFlag, null) > -1 : (_vm.actualBundle.bundle_configuration.channelDisplayOptions.attributesDisplayFlag)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.actualBundle.bundle_configuration.channelDisplayOptions.attributesDisplayFlag,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions, "attributesDisplayFlag", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions, "attributesDisplayFlag", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions, "attributesDisplayFlag", $$c)
        }
      }, _vm.saveNewBundleConfiguration]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelShowTags[_vm.actualLanguage]) + "\n                ")])]) : _vm._e()])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayPieChart === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayPieChart()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayPieChart) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayPieChart()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "h4 block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayPieChart()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pie-chart fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.blocLabelPieCharts[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayPieChart) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 push"
  }, [_c('h6', {
    staticClass: "font-w200"
  }, [_vm._v(_vm._s(_vm.textConfigPieChart[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.bundleConfigEditFlag) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 push"
  }, [_c('label', {
    staticClass: "css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actualBundle.bundle_configuration.channelDisplayOptions.pieChartDisplayFlag),
      expression: "actualBundle.bundle_configuration.channelDisplayOptions.pieChartDisplayFlag"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.actualBundle.bundle_configuration.channelDisplayOptions.pieChartDisplayFlag) ? _vm._i(_vm.actualBundle.bundle_configuration.channelDisplayOptions.pieChartDisplayFlag, null) > -1 : (_vm.actualBundle.bundle_configuration.channelDisplayOptions.pieChartDisplayFlag)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.actualBundle.bundle_configuration.channelDisplayOptions.pieChartDisplayFlag,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions, "pieChartDisplayFlag", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions, "pieChartDisplayFlag", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions, "pieChartDisplayFlag", $$c)
        }
      }, _vm.saveNewBundleConfiguration]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelDisplayPieChart[_vm.actualLanguage]) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 push"
  }, [_c('label', {
    staticClass: "css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actualBundle.bundle_configuration.channelDisplayOptions.displayChannelLocalizationFlag),
      expression: "actualBundle.bundle_configuration.channelDisplayOptions.displayChannelLocalizationFlag"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.actualBundle.bundle_configuration.channelDisplayOptions.displayChannelLocalizationFlag) ? _vm._i(_vm.actualBundle.bundle_configuration.channelDisplayOptions.displayChannelLocalizationFlag, null) > -1 : (_vm.actualBundle.bundle_configuration.channelDisplayOptions.displayChannelLocalizationFlag)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.actualBundle.bundle_configuration.channelDisplayOptions.displayChannelLocalizationFlag,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions, "displayChannelLocalizationFlag", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions, "displayChannelLocalizationFlag", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions, "displayChannelLocalizationFlag", $$c)
        }
      }, _vm.saveNewBundleConfiguration]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelDisplayChannelLocalisation[_vm.actualLanguage]) + "\n                ")])])]) : _vm._e()])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayChannelAverage === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayChannelAverage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayChannelAverage) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayChannelAverage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "h4 block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayChannelAverage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-tasks fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.blocLabelMovingAverage[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayChannelAverage) ? _c('div', {
    staticClass: "block-content"
  }, [(_vm.bundleConfigEditFlag) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 items-push"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h6', {
    staticClass: "h3 font-w200"
  }, [_vm._v(_vm._s(_vm.textConfigMovingAverage[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "h4 css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayEnable),
      expression: "actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayEnable"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayEnable) ? _vm._i(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayEnable, null) > -1 : (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayEnable)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayEnable,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayEnable", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayEnable", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayEnable", $$c)
        }
      }, _vm.saveNewBundleConfiguration]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelDisplayMA[_vm.actualLanguage]) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "h4 css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayActual),
      expression: "actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayActual"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayActual) ? _vm._i(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayActual, null) > -1 : (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayActual)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayActual,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayActual", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayActual", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayActual", $$c)
        }
      }, _vm.saveNewBundleConfiguration]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelMA_DisplayActual[_vm.actualLanguage]) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "h4 css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA001H),
      expression: "actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA001H"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA001H) ? _vm._i(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA001H, null) > -1 : (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA001H)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA001H,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA001H", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA001H", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA001H", $$c)
        }
      }, _vm.saveNewBundleConfiguration]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelMA_DisplayHr[_vm.actualLanguage]) + " 1 hr\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "h4 css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA004H),
      expression: "actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA004H"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA004H) ? _vm._i(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA004H, null) > -1 : (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA004H)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA004H,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA004H", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA004H", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA004H", $$c)
        }
      }, _vm.saveNewBundleConfiguration]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelMA_DisplayHr[_vm.actualLanguage]) + " 4 hr\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "h4 css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA006H),
      expression: "actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA006H"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA006H) ? _vm._i(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA006H, null) > -1 : (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA006H)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA006H,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA006H", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA006H", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA006H", $$c)
        }
      }, _vm.saveNewBundleConfiguration]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelMA_DisplayHr[_vm.actualLanguage]) + " 6 hr\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "h4 css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA012H),
      expression: "actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA012H"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA012H) ? _vm._i(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA012H, null) > -1 : (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA012H)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA012H,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA012H", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA012H", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA012H", $$c)
        }
      }, _vm.saveNewBundleConfiguration]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelMA_DisplayHr[_vm.actualLanguage]) + " 12 hr\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "h4 css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA024H),
      expression: "actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA024H"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA024H) ? _vm._i(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA024H, null) > -1 : (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA024H)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA024H,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA024H", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA024H", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA024H", $$c)
        }
      }, _vm.saveNewBundleConfiguration]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelMA_DisplayHr[_vm.actualLanguage]) + " 1 " + _vm._s(_vm.buttonLabelMA_Day[_vm.actualLanguage]) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "h4 css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA072H),
      expression: "actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA072H"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA072H) ? _vm._i(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA072H, null) > -1 : (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA072H)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA072H,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA072H", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA072H", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA072H", $$c)
        }
      }, _vm.saveNewBundleConfiguration]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelMA_DisplayHr[_vm.actualLanguage]) + " 3 " + _vm._s(_vm.buttonLabelMA_Days[_vm.actualLanguage]) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "h4 css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA168H),
      expression: "actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA168H"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA168H) ? _vm._i(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA168H, null) > -1 : (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA168H)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA168H,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA168H", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA168H", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA168H", $$c)
        }
      }, _vm.saveNewBundleConfiguration]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelMA_DisplayHr[_vm.actualLanguage]) + " 7 " + _vm._s(_vm.buttonLabelMA_Days[_vm.actualLanguage]) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "h4 css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA336H),
      expression: "actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA336H"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA336H) ? _vm._i(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA336H, null) > -1 : (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA336H)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA336H,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA336H", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA336H", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA336H", $$c)
        }
      }, _vm.saveNewBundleConfiguration]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelMA_DisplayHr[_vm.actualLanguage]) + " 14 " + _vm._s(_vm.buttonLabelMA_Days[_vm.actualLanguage]) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "h4 css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA720H),
      expression: "actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA720H"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA720H) ? _vm._i(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA720H, null) > -1 : (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA720H)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA720H,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA720H", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA720H", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA720H", $$c)
        }
      }, _vm.saveNewBundleConfiguration]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelMA_DisplayHr[_vm.actualLanguage]) + " 30 " + _vm._s(_vm.buttonLabelMA_Days[_vm.actualLanguage]) + "\n                    ")])])])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12",
    attrs: {
      "for": "example-select"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "example-select",
      "name": "example-select",
      "size": "1"
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Sélectionner")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Résidentiel")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Commercial")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Industriel")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12",
    attrs: {
      "for": "example-select"
    }
  }, [_vm._v("Nombre d'occupant")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "example-select",
      "name": "example-select",
      "size": "1"
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Sélectionner")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12",
    attrs: {
      "for": "example-multiple-select"
    }
  }, [_vm._v("Sélection Multiple")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "example-multiple-select",
      "name": "example-multiple-select",
      "size": "5",
      "multiple": ""
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Option #1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Option #2")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Option #3")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Option #4")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("Option #5")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("Option #6")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("Option #7")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("Option #8")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("Option #9")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("Option #10")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('hr')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-377927a0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/configuration/ConfigBundle.vue
// module id = 1512
// module chunks = 4